import { jsxs as d, jsx as t, Fragment as T } from "react/jsx-runtime";
import { withManagedProps as j } from "@made-people/managed-props";
import { z as e } from "zod";
import { withZod as v } from "@made-people/react-prop-guard";
import { Fragment as U } from "react";
import { footerTemplate1Blueprint as F, footerTemplate2Blueprint as E } from "./index-blueprint.es.js";
import { componentWrapperSchema as P, ComponentWrapper as W } from "@made-people/blueprint-component-wrapper";
import { headingSchema as f, Heading as N } from "@made-people/blueprint-heading";
import { countrySelectorUpdateOnChangeSchema as $, CountrySelectorUpdateOnChange as x } from "@made-people/blueprint-site-settings";
import { Markdown as k } from "@made-people/blueprint-markdown";
import { linkAsLinkSchema as S, LinkAsLink as L } from "@made-people/blueprint-link";
import { partnerLogosSchema as B, PartnerLogos as C } from "@made-people/blueprint-partner-logos";
import { overlayEventEmitter as H } from "@made-people/blueprint-overlay";
import { useTranslate as M } from "@made-people/grease-translations";
import { Accordion as R } from "@made-people/blueprint-accordion";
import { newsletterSignupPropsSchema as w, NewsletterSignup as Z } from "@made-people/blueprint-newsletter-signup";
import "@headlessui/react";
import "@made-people/blueprint";
const z = e.object({
  layout: P.shape.layout.optional(),
  variants: e.custom().optional(),
  requiredAge: e.object({
    isEnabled: e.boolean().optional(),
    age: e.number().or(e.string()).optional(),
    label: e.string().optional()
  }).optional(),
  menuHeading: f.optional(),
  contactHeading: f.optional(),
  countrySelector: $.optional(),
  address: e.string().optional(),
  contactInformation: e.string().optional(),
  menu: S.array().optional(),
  partnerLogos: B.optional()
});
function G(n) {
  if (!n)
    return null;
  const c = n.split(`
`);
  return c.map((p, m) => /* @__PURE__ */ d(U, { children: [
    p,
    m < c.length - 1 && /* @__PURE__ */ t("br", {})
  ] }, m));
}
const I = j(
  "FooterTemplate1",
  v(
    {
      schema: z,
      defaultProps: {
        requiredAge: {
          isEnabled: !1
        }
      }
    },
    ({
      variants: n,
      countrySelector: c,
      menuHeading: p,
      contactHeading: m,
      layout: s,
      requiredAge: o,
      menu: u,
      address: i,
      contactInformation: l,
      partnerLogos: g
    }) => {
      const a = F.main.styles(n);
      return M(), /* @__PURE__ */ d(
        W,
        {
          className: a.wrapper,
          layout: s,
          background: a.background,
          children: [
            (o == null ? void 0 : o.age) && (o == null ? void 0 : o.isEnabled) && /* @__PURE__ */ d("div", { className: a.requiredAgeWrapper, children: [
              /* @__PURE__ */ t("span", { className: a.requiredAge, children: o.age }),
              /* @__PURE__ */ t("span", { className: a.requiredAgeLabel, children: o.label && G(o.label) })
            ] }),
            /* @__PURE__ */ t("div", { className: a.countries, children: /* @__PURE__ */ t(
              x,
              {
                ...c,
                as: "button",
                listBoxButtonSettings: {
                  onClick: () => {
                    H.emit("open", {
                      overlayId: "site-settings"
                    });
                  }
                }
              }
            ) }),
            u && /* @__PURE__ */ d("div", { className: a.menuWrapper, children: [
              p && /* @__PURE__ */ t(N, { className: a.menuHeading, ...p }),
              /* @__PURE__ */ t("div", { className: a.menu, children: u.map((r, h) => /* @__PURE__ */ t(
                L,
                {
                  variants: { size: "inherit" },
                  ...r
                },
                `footer-${h}`
              )) })
            ] }),
            l && /* @__PURE__ */ d("div", { className: a.contactWrapper, children: [
              m && /* @__PURE__ */ t(N, { className: a.contactHeading, ...m }),
              /* @__PURE__ */ t(
                k,
                {
                  content: l,
                  className: a.contactRichtext
                }
              )
            ] }),
            /* @__PURE__ */ t(
              C,
              {
                template: "template1",
                blueprint: F.partnerLogos,
                ...g,
                className: a.partnerLogos
              }
            ),
            i && /* @__PURE__ */ t(k, { content: i, className: a.addressRichtext })
          ]
        }
      );
    }
  )
), D = e.object({
  template: e.literal("template2"),
  layout: P.shape.layout.optional(),
  variants: e.custom().optional(),
  contactHeading: f.optional(),
  countrySelector: $.optional(),
  text: e.string().optional(),
  newsletter: e.object({
    settings: w.optional(),
    isEnabled: e.boolean().optional()
  }).optional(),
  navigation: e.object({
    as: e.array(e.enum(["accordion", "list"])).optional(),
    headings: f.optional(),
    // used to pass settings through default props
    links: S.optional(),
    // used to pass settings through default props
    menus: e.array(
      e.object({
        heading: f.optional(),
        links: S.array().optional()
      })
    ).optional()
  }).optional(),
  logo: e.custom().optional(),
  partnerLogos: B.optional()
}), J = j(
  "FooterTemplate2",
  v(
    {
      schema: D,
      defaultProps: {
        template: "template2",
        navigation: { as: ["accordion", "list"] }
      }
    },
    ({
      variants: n,
      countrySelector: c,
      logo: p,
      layout: m,
      navigation: s,
      newsletter: o,
      text: u,
      partnerLogos: i
    }) => {
      var g, a;
      const l = E.main.styles(n);
      return /* @__PURE__ */ d(
        W,
        {
          className: l.wrapper,
          layout: { ...m },
          background: l.background,
          children: [
            (o == null ? void 0 : o.isEnabled) && /* @__PURE__ */ t(Z, { ...o == null ? void 0 : o.settings }),
            u && /* @__PURE__ */ t(k, { content: u, className: l.text }),
            (s == null ? void 0 : s.menus) && /* @__PURE__ */ d(T, { children: [
              ((g = s.as) == null ? void 0 : g.includes("accordion")) && /* @__PURE__ */ t("div", { className: l.menuAccordion, children: /* @__PURE__ */ t(
                R,
                {
                  blueprint: E.accordion,
                  layout: {
                    spacing: { applySpacing: "false" },
                    position: { applyPosition: "false" }
                  },
                  items: s.menus.map((r, h) => {
                    var b;
                    return {
                      content: {
                        value: h.toString(),
                        trigger: (b = r == null ? void 0 : r.heading) == null ? void 0 : b.heading,
                        content: /* @__PURE__ */ t(T, { children: r.links && r.links.map((y, O) => /* @__PURE__ */ t(
                          L,
                          {
                            variants: { size: "inherit" },
                            ...s.links,
                            ...y
                          },
                          `menu-${h}-link-${O}`
                        )) })
                      }
                    };
                  })
                }
              ) }),
              ((a = s.as) == null ? void 0 : a.includes("list")) && /* @__PURE__ */ t("div", { className: l.menuList, children: s.menus.map((r, h) => /* @__PURE__ */ d(
                "div",
                {
                  className: l.menuListMenu,
                  children: [
                    r.heading && /* @__PURE__ */ t(
                      N,
                      {
                        ...s.headings,
                        ...r.heading,
                        className: l.menuListMenuHeading
                      }
                    ),
                    r.links && r.links.map((b, y) => /* @__PURE__ */ t(
                      L,
                      {
                        variants: { size: "inherit" },
                        ...s.links,
                        ...b
                      },
                      `menu-${h}-link-${y}`
                    ))
                  ]
                },
                `menu-${h}`
              )) })
            ] }),
            /* @__PURE__ */ t("div", { className: l.countries, children: /* @__PURE__ */ t(
              x,
              {
                ...c,
                as: "button",
                listBoxButtonSettings: {
                  onClick: () => {
                    H.emit("open", {
                      overlayId: "site-settings"
                    });
                  }
                }
              }
            ) }),
            /* @__PURE__ */ t(
              C,
              {
                template: "template1",
                className: l.partnerLogos,
                ...i
              }
            ),
            p && /* @__PURE__ */ t("div", { className: l.logo, children: p })
          ]
        }
      );
    }
  )
), K = e.discriminatedUnion("template", [
  z.extend({ template: e.literal("template1") }),
  D
]), mt = j(
  "Footer",
  v(
    { schema: K, defaultProps: { template: "template1" } },
    (n) => n.template === "template1" ? /* @__PURE__ */ t(I, { ...n }) : n.template === "template2" ? /* @__PURE__ */ t(J, { ...n }) : null
  )
);
function dt(n) {
  const c = Object.keys(n);
  if (c.length === 0)
    throw new Error("templateMap cannot be empty");
  const p = c.find((i) => n[i].isDefault) || c[0], s = c.map((i) => {
    const l = n[i].schema;
    return e.object({ template: e.literal(i) }).merge(l);
  }), o = e.discriminatedUnion("template", s);
  return e.preprocess((i) => i && typeof i == "object" && !("template" in i) ? { template: p, ...i } : i, o);
}
export {
  mt as Footer,
  I as FooterTemplate1,
  J as FooterTemplate2,
  dt as createDiscriminatedSchema,
  K as footerSchema,
  z as footerTemplate1Schema,
  D as footerTemplate2Schema
};
//# sourceMappingURL=index.es.js.map
